export type LegPerfBreakdown = {
  register: string;
  reinvest: string;
};

export type DailyPerfPeriod = {
  total: string;
  register: string;
  reinvest: string;
  left: LegPerfBreakdown;
  right: LegPerfBreakdown;
};

export type WalletDailyPerf = {
  yesterday: DailyPerfPeriod;
  today: DailyPerfPeriod;
  big_market_leg: 'L' | 'R';
  leg_totals: { left: string; right: string };
};

export const PERF_CELL_KEYS = ['yesterday_perf', 'today_perf'] as const;
export type PerfCellKey = (typeof PERF_CELL_KEYS)[number];

export function isPerfCellKey(key: string): key is PerfCellKey {
  return key === 'yesterday_perf' || key === 'today_perf';
}
